import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { MsisdnService } from 'src/app/service/msisdn.service';
import { SubscriptionService } from 'src/app/service/subscription.service';
import { PortalService } from 'src/app/service/portal.service';
import { AgencyService } from 'src/app/service/agency.service';

declare var gtag;

@Component({
  selector: 'app-lp',
  templateUrl: './lp.component.html',
  styleUrls: ['./lp.component.css'],
})
export class LpComponent implements OnInit {
  source: string;
  msisdn: string;
  wifiModalBox: boolean = false;
  dayModalBox: boolean = false;
  invalidNo: boolean = false;
  subModalBox: boolean = false;
  msg: any;
  subCheckTimer: any;
  constructor(
    private datePipe: DatePipe,
    private agencyService: AgencyService,
    private msisdnService: MsisdnService,
    private subscriptionService: SubscriptionService,
    private portalService: PortalService,
    private _router: Router,
    private spinner: NgxSpinnerService
  ) {}

  async ngOnInit() {
    // await this.agencyService.setAgencyParameters();
    this.source = sessionStorage.getItem('source');
    console.log('this.source..............', this.source);

    //this.mobile_number = '719767789677'
    // this.mobile_number = '191564389595'
    // localStorage.setItem('gamezklub-mobile', this.mobile_number);

    if (this.source == 'SIGADS') {
      gtag('config', 'AW-11092028282');
    }

    //IP
    await this.portalService.getIPAddress();

    this.msisdn = localStorage.getItem('msisdn')
      ? localStorage.getItem('msisdn')
      : '0';

    if (
      this.msisdn == null ||
      this.msisdn == undefined ||
      this.msisdn == 'NA' ||
      this.msisdn == 'null'
    ) {
      //mobile_number get call this

      await this.msisdnService.fetchMSISDN();

      await this.portalService.visitorLogEntryForLP();
      // check subscribeUser
      let isSubscribed = await this.subscriptionService.checkSubscription();
      if (isSubscribed == true) {
        this._router.navigateByUrl('/home');
      }
    } else {
      await this.portalService.visitorLogEntryForLP();
      let isSubscribed = await this.subscriptionService.checkSubscription();
      if (isSubscribed == true) {
        this._router.navigateByUrl('/home');
      } else {
        // 18/09/23 sachin requirment source direct redirect
        if (this.source?.indexOf('OF01') == 0) {
          console.log('Check..............');
          this.msg = this.subscriptionService.getCGDetails();
          if (this.msg) {
            this.subCheckTimer = setInterval(() => {
              console.log('LANDING_PAGE | TIMER STARTED.......');
              this.checkUserSubscription();
            }, 2000);
          }
        }
      }
    }

    if (localStorage.getItem('redirectsub') == '1') {
      this._router.navigate(['/loading']);
    }
  }
  //Modal popups  this
  dayModal() {
    this.dayModalBox = true;
  }
  wifiModal() {
    this.wifiModalBox = true;
  }
  subModal() {
    sessionStorage.setItem('isSubscribed', '1');
    this.subModalBox = true;
  }
  invalidModal() {
    this.invalidNo = true;
  }

  closeModal() {
    console.log('click');
    this.wifiModalBox = false;
    this.subModalBox = false;
    this._router.navigateByUrl('/home');
    // this.spinner.hide();
  }
  closeinvalidModal() {
    this.invalidNo = false;
    // this.spinner.hide();
  }

  //Subcription click  this
  async click() {
    let msisdn = localStorage.getItem('msisdn');
    if (localStorage.getItem('redirectsub') == '1') {
      this._router.navigate(['/loading']);
    } else {
      if (this.source == 'SIGADS') {
        //google User
        this.subscriptionService.checkSubscription();
        if (sessionStorage.getItem('isSubscribed') == '1') {
          this._router.navigateByUrl('/home');
        } else {
          let isDifferenceDays =
            await this.subscriptionService.checkDateDifference();
          //if (isDifferenceDays == true) {
          this.msg = this.subscriptionService.getCGDetails();
          if (this.msg) {
            this.subCheckTimer = setInterval(() => {
              console.log('LANDING_PAGE | TIMER STARTED.......');
              this.checkUserSubscription();
            }, 2000);
          }
          // } else {
          //   this.dayModal()
          // }
        }
        //End Code

        // sessionStorage.setItem('isSubscribed', '1');
        // this._router.navigate(['/home'])
      } else {
        console.log('NO MSISDN');
        if (msisdn == null || msisdn == undefined || msisdn == 'NA') {
          console.log('NO MSISDN 2');
          this.wifiModal();
        } else {
          this.subscriptionService.checkSubscription();
          if (sessionStorage.getItem('isSubscribed') == '1') {
            this._router.navigateByUrl('/home');
          } else {
            let isDifferenceDays =
              await this.subscriptionService.checkDateDifference();
            //if (isDifferenceDays == true) {
            this.msg = this.subscriptionService.getCGDetails();
            if (this.msg) {
              this.subCheckTimer = setInterval(() => {
                console.log('LANDING_PAGE | TIMER STARTED.......');
                this.checkUserSubscription();
              }, 2000);
            }
            // } else {
            //   this.dayModal()
            // }
          }
        }
      }
    }
  }

  async checkUserSubscription() {
    let isSubscribed = await this.subscriptionService.checkSubscription();
    if (isSubscribed == true) {
      if (this.subCheckTimer) {
        clearInterval(this.subCheckTimer);
      }
      console.log('LANDING_PAGE | TIMER STOPED.......');
      this._router.navigate(['/home']);
    }
  }
}
